export default "__VITE_ASSET__uInslTIw__"